import React from 'react';
export const SiteHeader = () => {
  return <header className="bg-[#1a2e4a] p-0 border-b-[3px] border-[#e8c84a]" data-id="element-150">
      <div className="max-w-[900px] mx-auto px-[20px] py-[14px] flex items-center gap-[12px]" data-id="element-151">
        <div className="shrink-0" data-id="element-152">
          <div className="text-[22px] font-extrabold text-white tracking-[-0.5px]" data-id="element-153">
            Vi<span className="text-[#e8c84a]" data-id="element-154">We</span> Forum
          </div>
          <div className="text-[11px] text-[#8da4bc] tracking-[0.04em] mt-[2px]" data-id="element-155">
            Vital-Wegweiser Forum
          </div>
        </div>
        <nav className="ml-auto flex gap-[12px] md:gap-[20px] flex-wrap justify-end items-center" data-id="element-156">
          <span className="md:text-[10px] tracking-[0.08em] uppercase opacity-70 text-[12px] text-[#FFFFFF]" data-id="element-157">
            ANZEIGE
          </span>
          <a href="#" className="text-[11px] md:text-[12px] text-[#8da4bc] no-underline tracking-[0.03em] hover:text-white" data-id="element-158">
            Startseite
          </a>
          <a href="#" className="text-[11px] md:text-[12px] text-[#8da4bc] no-underline tracking-[0.03em] hover:text-white" data-id="element-159">
            Kategorien
          </a>
          <a href="#" className="text-[11px] md:text-[12px] text-[#8da4bc] no-underline tracking-[0.03em] hover:text-white hidden sm:inline" data-id="element-160">
            Mitglieder
          </a>
          <a href="#" className="text-[11px] md:text-[12px] text-[#8da4bc] no-underline tracking-[0.03em] hover:text-white" data-id="element-161">
            Anmelden
          </a>
        </nav>
      </div>
    </header>;
};